import React, { Component } from 'react'

export default class TwitterSocial extends Component {

  componentDidMount() {
    this.preloadWidgetScript()
  }
  
  preloadWidgetScript = () => {
    const script = document.createElement('script')
    script.async = true
    script.src = '//platform.twitter.com/widgets.js'
    script.charset='utf-8'
    document.body.appendChild(script)
  }

  render() {
    // May need to consider stripping off a trailing `/` character when the url
    // may have it. Some local testing showed that the twitter widget may error out
    // when that extra slash is present. Not 100% sure how the URL's are formatted
    // when they come in from the API at this point.
    return(
      <div hidden={this.props.hidden}>
        <a  className   ="twitter-timeline" 
            data-width  ={this.props.width}
            data-height ={this.props.height}
            href        ={this.props.url}></a>
      </div>
    )
  }
}

TwitterSocial.defaultProps = {
  hidden:     true,
  width:      '300',
  height:     '500',
  url:        'https://twitter.com/showcaseidx'
}


// WEBPACK FOOTER //
// client/components/social/TwitterSocial.js